import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/funding_sources/authorize_iframe/{district_id}
export const authorizeIframe = async (districtId: TDistrictId) => {
  const response = await new Request().get('/ajax/funding_sources/authorize_iframe/' + districtId)
  return Util.Obj.keysToCamel(response.data)
}
